'use strict';
import _ from 'lodash';

export default class AccountModifyController 
{
	/*@ngInject*/
	constructor(Auth, $controller, $scope, $http, $q, $log, ValidationService, messageService) 
	{
		//console.log("::AccountModifyController");
		// Esta linea es necesaria para que el CommonController pueda acceder a vm desde $scope.vm
		//angular.extend(this, $controller('AccountCommonController', {$scope: $scope}));
		
		this.Auth = Auth;
		this.$http = $http;
		this.$q = $q;
		this.$log = $log;
		this.validation = new ValidationService();
		this.messageService = messageService;

		this.user = {};
		this.emailDisabled = true;
		this.showError = false;
		this.showSuccess = false;

		Auth.getCurrentUser((user) =>
		{
			this.user = {
				name: user.name,
				surname: user.surname,
				nick: user.nick,
				email: user.email,
				country_id: user.country,
				region1_id: user.region1,
				region2_id: user.region2,
				club: user.club,
				twitter: user.twitter,
				web: user.web,
				about: user.about
			}

			this.$http.post("/api/geonames/countries")
			.then(response => 
			{
				this.countries = response.data;

				let country = this.user.country_id;
				let id = _.findIndex(this.countries, function(c) { return c.iso2 === country });
				if (id != -1)
				{
					this.user.country = this.countries[id];
					this.$http.post("/api/geonames/regions1/" + country)
					.then(response => 
					{
						this.regions1 = response.data;

						let region1 = this.user.region1_id;
						let id = _.findIndex(this.regions1, function(r) { return r.id === region1 });
						if (id != -1)
						{
							this.user.region1 = this.regions1[id];
							this.$http.post("/api/geonames/regions2/" + region1)
							.then(response => 
							{
								this.regions2 = response.data;

								let region2 = this.user.region2_id;
								let id = _.findIndex(this.regions2, function(r) { return r.id === region2 });
								if (id != -1)
								{
									this.user.region2 = this.regions2[id];
								}
							});
						}
					});
				}
			});
		});
	}

	CheckExistingEmail() 
	{
		// Create a fake promise for email validation
 		var fake = this.$q.defer();
		fake.resolve({isValid: true});
		return fake.promise;
	}
	
	UpdateUser(form)
	{
		this.showError = false;
		this.showSuccess = false;
		
		if (!this.validation.checkFormValidity(form)) 
		{
			this.showError = true;
			return;
		}

		var data = {
			name: this.user.name,
			surname: this.user.surname,
			nick: this.user.nick,
			email: this.user.email,
			password: this.user.password,
			country: this.user.country ? this.user.country.iso2 : null,
			region1: this.user.region1 ? this.user.region1.id : null,
			region2: this.user.region2 ? this.user.region2.id : null,
			club: this.user.club,
			twitter: this.user.twitter,
			web: this.user.web,
			about: this.user.about
		};
		
		this.Auth.updateUser(data)
		.then(() => {
			this.showSuccess = true;
		})
		.catch(err => {
			this.$log.warn(err);
			this.showError = false;
			this.messageService.Error(err.data);
		});
	}
}


// WEBPACK FOOTER //
// ./client/app/account/account/account_modify.controller.js